'use client';

import { forwardRef } from 'react';
import type { ReactNode } from 'react';
import type { ActionIconProps as MantineActionIconProps } from '@mantine/core';
import { ActionIcon as MantineActionIcon, createPolymorphicComponent } from '@mantine/core';

import type { LockedPolymorphic, LockedProps } from '../types';

export type ActionIconProps = Omit<MantineActionIconProps, LockedProps> & {
  children?: ReactNode;
};

const _ActionIcon = forwardRef<HTMLButtonElement, ActionIconProps>(({ variant, ...props }, ref) => {
  // v7 changed Mantine's default variant from 'subtle' to 'filled'; keep icon buttons transparent
  // with a tinted hover. Resolved after the spread so `variant={cond ? 'light' : undefined}` — the
  // idiomatic way to apply a variant conditionally — falls back to ours, not Mantine's 'filled'.
  return <MantineActionIcon ref={ref} {...props} variant={variant ?? 'subtle'} />;
});

_ActionIcon.displayName = 'ActionIcon';

export const ActionIcon = createPolymorphicComponent<'button', ActionIconProps>(
  _ActionIcon,
) as LockedPolymorphic<'button', ActionIconProps>;
